/**
 * @module app.shared
 */

import { AppLogger } from 'app/shared/lib/logging/app-logger';

export class I18NextLogger {

    public readonly type = 'logger';

    constructor(private readonly logger: AppLogger) { }

    public log(args: any) {
        const parsed = this.parseArgs(args);
        this.logger.info(parsed[0], parsed[1]);
    }

    public warn(args: any) {
        const parsed = this.parseArgs(args);
        this.logger.warn(parsed[0], parsed[1]);
    }

    public error(args: any) {
        const parsed = this.parseArgs(args);
        this.logger.error(parsed[0], parsed[1]);
    }

    private parseArgs(args: any): [string, any] {
        if(typeof args === 'string') {
            return [args, undefined];
        }
        else if(Array.isArray(args)) {
            if(args.length == 0) {
                return ['', undefined];
            }
            if(args.length > 0) {
                const message = `${args[0]}`;
                if(args.length > 1) {
                    return [message, args.slice(1)];
                }
                return [message, undefined];
            }
        }
        return ['', args];
    }

}
